<template>
    <div>
      <!-- Header -->
      <CRow>
        <CCol col="sm-12">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="sm-9">
                  <div class="c-avatar c-avatar-stack c-avatar-xxl float-left my-2 mr-3">
                    <img v-if="!urlImagenEmpleado" src="../../public/static/no_user.jpg" alt="Foto empleado" class="c-avatar-img" />
                    <URLImg v-if="urlImagenEmpleado" class="c-avatar-img" :url="urlImagenEmpleado"/>
                  </div>
                  <h3 class="text-medium-emphasis">{{ $store.state.user.data.empleado }}</h3>
                  <h5 class="text-muted mt-2">Muy {{ saludoHorario }}, bienvenido a <strong>&Oacute;ptimo SBM</strong></h5>
                  <p>La TRM del dia de hoy es <span class="h5"><strong>${{ $store.state.user.data.TRM }}</strong></span></p>
                </CCol>
                <CCol col="sm-3" class="text-right">
                  <img :src="urlHeader" alt="" class="img-fluid">
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <!-- Content -->
      <!-- <CRow>
        <CCol col="12" sm="12">
          <div class="metro-menu">
            <div class="tile small bg-s3yellow">
              <i class="bi bi-bar-chart-line"></i>
              <span>Power BI</span>
            </div>
          </div>
        </CCol>
      </CRow> -->

      <CRow>
        <CCol col="6" sm="6">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="12" sm="6">
                  <CustomerQuantityIndicatorPanel 
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    typeIndicator="CA"
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" />
                </CCol>
                <CCol col="12" sm="6">
                  <CustomerQuantityIndicatorPanel 
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    typeIndicator="CN"
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" />
                </CCol>
                <CCol col="12" sm="6">
                  <CustomerQuantityIndicatorPanel 
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    typeIndicator="CP"
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" />
                </CCol>
                <CCol col="12" sm="6">
                  <CustomerQuantityIndicatorPanel 
                    :initialDate="fechaInicial" 
                    :finalDate="fechaFinal" 
                    typeIndicator="PN"
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null" />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol col="6" sm="6">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="12" sm="6">
                  <div class="puntero" @click="goToSellbills()">
                    <DocumentValuesIndicatorPanel 
                      typeIndicator="Ventas" 
                      :initialDate="fechaInicial"
                      :finalDate="fechaFinal"
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </DocumentValuesIndicatorPanel>
                  </div>
                </CCol>
                <CCol col="12" sm="6">
                  <div class="puntero" @click="goToDeliveryNote()">
                    <DocumentValuesIndicatorPanel 
                      typeIndicator="Remisiones Periodo"
                      :initialDate="fechaInicial"
                      :finalDate="fechaFinal"
                      :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                      :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                    </DocumentValuesIndicatorPanel>
                  </div>
                </CCol>
                <!-- <CCol col="12" sm="6" v-if="$store.state.user.data.tipo_Empleado === 'V'">
                  <CCallout color="s3orange">
                    <span class="text-muted">Cotizaciones</span>
                    <div @click="goToQuotes()" class="puntero">
                      <i class="bi bi-envelope-paper h2 text-s3orange mr-3"></i>
                      <strong class="h4">${{ formatter.format(valorCotizacionesRealizadas, 2) }}M</strong>
                    </div>
                  </CCallout>
                </CCol> -->
                <CCol col="12" sm="6">
                  <DocumentValuesIndicatorPanel
                    typeIndicator="Recaudos"
                    :initialDate="fechaInicial"
                    :finalDate="fechaFinal"
                    :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                    :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                  </DocumentValuesIndicatorPanel>
                </CCol>
                <CCol col="12" sm="6">
                  <!-- Pendiente de implementacion en Componente -->
                  <CCallout color="s3orange">
                    <span class="text-muted">Compras</span>
                    <br>
                    <Icon icon="fluent:shopping-bag-tag-24-regular" class="text-s3orange mt-1 mr-3" width="28"/>
                    <strong class="h4 align-middle">${{ formatter.format(valorCompras, 2) }}M</strong>
                  </CCallout>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol col="12" sm="12">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="12" sm="4">
                  <CCard class="h-100">
                    <CCardBody>
                      <PortfolioParticipationChart 
                        title="Cartera por Edades"
                        sizeColumns="6"
                        reportType="R"
                        :portfolioDays=0
                        :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null"
                        :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                      </PortfolioParticipationChart>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol col="12" sm="4">
                  <CCard class="h-100">
                    <CCardBody>
                      <CustomerPenetrationChart 
                        title="Penetración en Ventas" 
                        :initialDate="fechaInicial" 
                        :finalDate="fechaFinal" 
                        :idStaffGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null" 
                        :idEmployee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null">
                      </CustomerPenetrationChart>
                    </CCardBody>
                  </CCard>
                </CCol>
                <CCol col="12" sm="4">
                  <CCard class="h-100">
                    <CCardBody>
                      <MonthlySalesParticipationChart 
                        title="Ventas por Mes" 
                        :initialDate="fechaInicialAnio" 
                        :finalDate="fechaFinal" 
                        :employeeGroup="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null" 
                        :employee="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null"
                        :valuesDivisor="divisorValores">
                      </MonthlySalesParticipationChart>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol col="3" sm="3" v-if="$store.state.user.data.tipo_Empleado === 'A'">
          <SalesProfitPanel 
            title="Utilidad en Ventas"
            :initialDate="fechaInicial" 
            :finalDate="fechaFinal" 
            :typeUtility="'venta'"
            :staffGroupId="$store.state.user.data.tipo_Empleado === 'D' ? $store.state.user.data.id_GrupoPersonal : null" 
            :employeeId="$store.state.user.data.tipo_Empleado === 'V' ? $store.state.user.data.id_Empleado : null"
            :divisorValues="divisorValores">
          </SalesProfitPanel>
        </CCol>
      </CRow>
    </div>
</template>
<script>
  import moment from "moment";
  import { Icon } from "@iconify/vue2";
  import { formatter } from "@/general";
  import { 
    dataDashboardAdministracion
    // dataEfectividadCotizacionesVendedores,
    // dataCantidadClientesVendedores,
  } from "@/apiData";
  
  import URLImg from './containers/URLImg.vue'
  import CustomerQuantityIndicatorPanel from "./panels/CustomerQuantityIndicatorPanel.vue"
  import PortfolioParticipationChart from './charts/PortfolioParticipationChart.vue'
  import DocumentValuesIndicatorPanel from "@/components/panels/DocumentValuesIndicatorPanel.vue";
  import CustomerPenetrationChart from "@/components/charts/CustomerPenetrationChart.vue";
  import SalesProfitPanel from "@/modules/sales/components/panels/SalesProfitPanel.vue";
  import MonthlySalesParticipationChart from "@/modules/sales/components/charts/MonthlySalesParticipationChart.vue";

  export default {
    name: 'HomeAdministration',
    data() {
      return {
        formatter,
        rootPath: "",
        saludoHorario: "",
        divisorValores: 1000000,
        fechaInicial: 0,
        fechaFinal: 0,
        fechaInicialAnio: 0,
        periodoInicial: "",
        periodoFinal: "",
        valorCompras: 0,
        cantidadCotizacionesRealizadas: 0,
        cantidadCotizacionesFacturadas: 0,
        cantidadCotizacionesPendientes: 0,
        valorCotizacionesRealizadas: 0,
        valorCotizacionesFacturadas: 0,
        valorCotizacionesPendientes: 0,
        urlHeader: "",
        urlImagenEmpleado: ""
      }
    },
    components: {
      Icon,
      URLImg,
      CustomerQuantityIndicatorPanel,
      DocumentValuesIndicatorPanel,
      // SalesBudgetExecutionChart,
      SalesProfitPanel,
      PortfolioParticipationChart,
      CustomerPenetrationChart,
      MonthlySalesParticipationChart
    },
    created() {
      // Se asignan las variables requeridas antes que se monten los componentes
      this.fechaInicialAnio = moment().startOf("year").format("YYYY-MM-DD");
      this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");
    },
    mounted() {
      const randomNumber = Math.floor(Math.random() * 5) + 1
      
      this.rootPath = this.$router.currentRoute.fullPath;
      this.urlHeader = this.getUrlImg(`imgHeader_0${randomNumber}.png`)

      this.periodoInicial = moment().format("YYYYMM")
      this.periodoFinal = this.periodoInicial

      let hora = moment().format("HH")

      if (this.$store.state.user.data.url_ImagenFoto) {
        this.urlImagenEmpleado = `/consultas/api/descargaArchivo?F=${this.$store.state.user.data.url_ImagenFoto}`
      }

      if (hora >= 0 && hora < 4) {
        this.saludoHorario = "buena noche"
      } else if (hora >= 4 && hora < 12) {
        this.saludoHorario = "buen día"
      } else if (hora >= 12 && hora < 18) {
        this.saludoHorario = "buena tarde"
      } else {
        this.saludoHorario = "buena noche"
      }

      this.getDataKPISales();
    },
    methods: {
      async getDataKPISales() {
        try {
          const { response } = await dataDashboardAdministracion(
            this,
            this.fechaInicial,
            this.fechaFinal,
            this.$store.state.user.data.tipo_Empleado === "D" ? this.$store.state.user.data.idStaffGroup : null,
            this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null
          )

          this.valorCompras = (response.Valor_Compras / this.divisorValores)
        } catch (error) {
          console.log(error);
        }
      },
      goToSellbills() {
        this.$router.push({ path: "/empresa/movimientos/facturasventa" });
      },
      goToDeliveryNote() {
        this.$router.push({ path: "/empresa/movimientos/entregasmercancia" });
      },
      goToQuotes() {
        this.$router.push({ path: "/empresa/movimientos/cotizaciones" });
      },
      goToSalesProfit() {
        this.$router.push({ path: "/empresa/indicadores/dashboardventas/utilidadventasdocumentos" });
      },
      getUrlImg(str) {
        const images = require.context('../../public/static/img', false, /\.png$/)

        return images(`./${str}`)
      }
    }
  }
</script>
